export const HOME_GRATITUDES_CLICKED = 'HOME_GRATITUDES_CLICKED';

export const WORKSTREAM_STATUS_CHAT_STOP = 'WORKSTREAM_STATUS_CHAT_STOP';

export type AnalyticsKeys =
  | 'WEB_APP_LOADED'
  | 'LOGIN_FAILED'
  | 'LOGIN_SUCCESS'
  | 'LOGIN_REFRESH'
  | 'AUTH_SESSION_EXPIRED'
  | 'AUTH_REDIRECT_STARTED'
  | 'NOT_FOUND_PAGE_VIEWED'
  | 'TTVC_SUBSEQUENT'
  | 'TTVC_INIT'
  | 'GRATITUDE_SENT'
  | 'SEARCH_SHOWN'
  | 'SEARCH_SELECTED'
  | 'SEARCH_FILTER_SELECTED'
  | 'SEARCH_FILTER_RESULTS'
  | 'SEARCH_SHOW_MORE_CLICKED'
  | 'GLOBAL_SEARCH_SESSION_STARTED'
  | 'GLOBAL_SEARCH_RESULTS_VIEWED'
  | 'GLOBAL_SEARCH_RESULT_IMPRESSED'
  | 'GLOBAL_SEARCH_RESULT_SELECTED'
  | 'GLOBAL_SEARCH_SESSION_ENDED'
  | 'SEARCH_INSTANT_ANSWER_SHOWN'
  | 'SEARCH_INSTANT_ANSWER_CLICKED'
  | 'SEARCH_INSTANT_ANSWER_ASK_CLICKED'
  | 'SEARCH_INSTANT_ANSWER_SUMMARY_SHOWN'
  | 'AI_SEARCH_INTERACTION'
  | 'AI_SEARCH_DRAWER_VIEWED'
  | 'BADGE_MODAL_OPENED'
  | 'PROFILE_EMPLOYEE_LOCATION_OPENED'
  | 'PROFILE_EMPLOYEE_LOCATION_DISPLAYED'
  | 'PROFILE_EMPLOYEE_LOCATION_VIEW_ALL_CLICKED'
  | 'NOTIFICATION_TRAY_OPENED'
  | 'NOTIFICATION_INBOX_CLICKED'
  | 'NOTIFICATION_CTA_CLICKED'
  | 'NOTIFICATION_ARCHIVE_CLICKED'
  | 'NOTIFICATION_EMAIL_CLICKED'
  | 'NOTIFICATION_CLICKED'
  | 'NOTIFICATION_SETTINGS_CLICKED'
  | 'NOTIFICATION_CHANNEL_TOGGLED'
  | 'PROFILE_INTERACTION'
  | 'PROFILE_OPENED'
  | 'LOG_EXPERIMENT'
  | 'NEWS_VIEW_MORE_CLICKED'
  | 'NEWS_ADD_POST_CLICKED'
  | 'NEWS_EDIT_POST_CLICKED'
  | 'NEWS_THUMBNAIL_UPLOADED'
  | 'NEWS_VIEWED'
  | 'NEWS_LOADED'
  | 'NEWS_POST_ACTION'
  | 'HOME_RECENT_SEARCH'
  | 'HOME_PEOPLE_FILTER'
  | 'HOME_STOCK_CLICKED'
  | 'HOME_DASHBOARD_INTERACTION'
  | 'HOME_SURFACE_VIEWED'
  | 'HOME_TILE_SEEN'
  | 'HOME_TILE_DWELL'
  | 'HOME_VISIT_SUMMARY'
  | 'HOME_AGENDA_LOADED'
  | 'COMPANY_FEEDBACK_STARTED'
  | 'COMPANY_FEEDBACK_SUBMIT_CLICKED'
  | 'COMPANY_FEEDBACK_SUBMISSION_RESULT'
  | 'TEAMS_BREADCRUMB_CLICKED'
  | 'TEAM_LINK_CLICKED'
  | 'DCD_OWNERSHIP_SEARCH_OUTCOME'
  | 'DCD_OWNERSHIP_LEFT_NAV_RESULT_SELECTED_WITHOUT_SEARCH'
  | 'DCD_OWNERSHIP_DETAIL_INTERACTION'
  | 'DCD_OWNERSHIP_SERVICE_GRAPH_INTERACTION'
  | 'WORKSTREAM_MODIFY_VIEW'
  | 'TEAM_MODIFY_VIEW'
  | 'TRACKER_MODIFY_VIEW'
  | 'ORG_CHART_INTERACTION'
  | 'HOME_BANNER_CLICKED'
  | 'CONSTRUCTION_CREW_HOVERED'
  | 'MISSING_TRANSLATION'
  | 'STRATEGY_VIEW_SCORECARD'
  | 'SETTINGS_CLICKED'
  | 'TABLE_COLUMN_RESIZE'
  | 'TABLE_COLUMN_SORT'
  | 'WORKSTREAM_STATUS_UPDATE'
  | 'WORKSTREAM_CONTINUE_UPDATING_MODAL_SHOWN'
  | 'WORKSTREAM_CONTINUE_UPDATING_MODAL_DISMISSED'
  | 'WORKSTREAM_CONTINUE_UPDATING_CANDIDATE_SELECTED'
  | 'WORKSTREAM_CONTINUE_UPDATING_VIEW_MORE_CLICKED'
  | 'WORKSTREAM_CONTINUE_UPDATING_NO_CANDIDATES'
  | 'WORKSTREAM_CONTINUE_UPDATING_FETCH_FAILED'
  | 'WORKSTREAM_VIEW'
  | 'WORKSTREAM_DETAIL_VIEW'
  | 'WORKSTREAM_ONBOARDING'
  | 'WORKSTREAM_TABLE_FILTERS'
  | typeof HOME_GRATITUDES_CLICKED
  | 'WORKSTREAM_SETTINGS_CHANGED'
  | 'WORKSTREAM_SWITCHBOARD_HEADER_LINK_CLICKED'
  | 'WORKSTREAM_SWITCHBOARD_HOMEWORK_LINK_CLICKED'
  | 'WORKSTREAM_SWITCHBOARD_PHASE_SELECTED'
  | 'WORKSTREAM_SWITCHBOARD_TEAM_FIELD_CLICKED'
  | 'WORKSTREAM_DEPENDENCIES_EXPANDED'
  | 'WORKSTREAM_SUMMARY_VOTE'
  | 'WORKSTREAM_HEALTH_SCORE_OPENED'
  | 'API_FRONTEND_5XX'
  | 'API_FRONTEND_API_ERROR'
  | 'ERROR_PAGE'
  | 'WORKSTREAM_STATUS_TAB_SELECTED'
  | 'WORKSTREAM_STATUS_CHAT_ENTER_SEND'
  | typeof WORKSTREAM_STATUS_CHAT_STOP
  | 'WORKSTREAM_RECENT_PINNED'
  | 'WORKSTREAM_DRAWER_OPENED'
  | 'WORKSTREAM_DETAILS_TAB_CLICKED'
  | 'WORKSTREAM_DETAILS_NOTES_TOGGLED'
  | 'WORKSTREAM_NOTES_SAVED'
  | 'WORKSTREAM_DRAWER_COMMENT_CLICKED'
  | 'WORKSTREAM_MODIFIED'
  | 'WORKSTREAM_METRIC_STATUS_CHANGED'
  | 'WORKSTREAM_METRICS_SUBWORKSTREAMS_EXPANDED'
  | 'WORKSTREAM_METRICS_TIMEFRAME_CHANGED'
  | 'WORKSTREAM_RESOURCE_CLICKED'
  | 'WORKSTREAM_RESOURCE_EXPANDED'
  | 'WORKSTREAM_FOLLOW_TOGGLED'
  | 'WORKSTREAM_VIEW_CLICKED'
  | 'WORKSTREAM_V2_PERF_ROUTE_START'
  | 'WORKSTREAM_V2_PERF_ROUTE_READY'
  | 'WORKSTREAM_V2_PERF_TABLE_FIRST_PAINT'
  | 'WORKSTREAM_V2_SIDEBAR_TOGGLE'
  | 'WORKSTREAM_V2_PERF_QUERY_START'
  | 'WORKSTREAM_V2_PERF_QUERY_FIRST_PAGE'
  | 'WORKSTREAM_V2_PERF_QUERY_COMPLETE'
  | 'WORKSTREAM_V2_PERF_QUERY_ERROR'
  | 'WORKSTREAM_AUDIT_VIEWED'
  | 'WORKSTREAM_AUDIT_TAB_SELECTED'
  | 'WORKSTREAM_AUDIT_COMPANY_GROUP_TOGGLED'
  | 'WORKSTREAM_AUDIT_ROW_CLICKED'
  // TEMPORARY: an old /workstreams link translated (see legacyWorkstreamsLinks).
  | 'WORKSTREAM_LEGACY_LINK_OPENED'
  | 'EXEC_SPONSOR_INBOX_VIEWED'
  | 'EXEC_SPONSOR_INBOX_WORKSTREAM_VIEWED'
  | 'EXEC_SPONSOR_INBOX_INTERACTION'
  | 'WORKSTREAM_ENG_ROADMAP_VIEWED'
  | 'WORKSTREAM_ENG_ROADMAP_QUARTER_SELECTED'
  | 'WORKSTREAM_ENG_ROADMAP_GROUP_TOGGLED'
  | 'WORKSTREAM_ENG_ROADMAP_JIRA_CLICKED'
  | 'WORKSTREAM_ENG_ROADMAP_PAGINATION_REQUESTED'
  | 'WORKSTREAM_ENG_ROADMAP_PERF_SUMMARY_REQUEST'
  | 'WORKSTREAM_ENG_ROADMAP_PERF_GROUP_REQUEST'
  | 'WORKSTREAM_ENG_ROADMAP_PERF_SUMMARY_READY'
  | 'WORKSTREAM_ENG_ROADMAP_PERF_FIRST_CONTENT'
  | 'WORKSTREAM_ENG_ROADMAP_PERF_GROUP_READY'
  | 'WORKSTREAM_ENG_ROADMAP_SNAPSHOT_REFRESHED'
  | 'ROADMAP_DEPENDENCIES_VIEWED'
  | 'ROADMAP_DEPENDENCIES_FILTER_CHANGED'
  | 'ROADMAP_DEPENDENCY_GROUP_TOGGLED'
  | 'ROADMAP_DEPENDENCIES_EXPAND_ALL'
  | 'ROADMAP_DEPENDENCY_JIRA_OPENED'
  | 'AI_SUGGESTION_ACTION'
  | 'AI_TOOLBAR_GENERATE'
  | 'AI_TOOLBAR_GENERATE_ACTION'
  | 'AI_AUTO_PROCESSING_REQUEST_SENT'
  | 'AI_AUTO_PROCESSING_RESPONSE_RECEIVED'
  | 'AI_AUTO_PROCESSING_APPLIED'
  | 'EDITOR_TOOLBAR_BUTTON_CLICKED'
  | 'STRATEGY_SCORES_CLICK'
  | 'STRATEGY_TITLE_CLICK'
  | 'RICH_TEXT_AREA_PASTE'
  | 'WORKSTREAM_COACH_VOTE'
  | 'WORKSTREAM_AI_COACH_ITERATE_COMPLETE'
  | 'PLANNING_DOC_NAV_OVERFLOW_OPENED'
  | 'PLANNING_DOC_NAV_MENU_ITEM_CLICKED'
  | 'PLANNING_DOC_NAV_COPY_LINK_CLICKED'
  | 'PLANNING_DOC_PERF_MEMORY_USAGE'
  | 'NAV_ITEM_CLICKED'
  | 'KNOWLEDGE_CATEGORY_SELECTED'
  | 'KNOWLEDGE_PAGE_VIEWED'
  | 'KNOWLEDGE_CATEGORY_VIEWED'
  | 'KNOWLEDGE_HOME_VIEWED'
  | 'KNOWLEDGE_GUIDE_VIEWED'
  | 'KNOWLEDGE_HOME_SEARCHED'
  | 'KNOWLEDGE_HOME_ITEM_CLICKED'
  | 'KNOWLEDGE_MENU_CLOSED'
  | 'MCP_SETUP_VIEWED'
  | 'MCP_SETUP_CTA_CLICKED'
  | 'MCP_SETUP_COPIED'
  | 'MCP_SETUP_CLIENT_SELECTED'
  | 'AUTODRAFT_SETUP_OPENED'
  | 'AUTODRAFT_SETUP_MODE_SELECTED'
  | 'AUTODRAFT_SETUP_STEP_COMPLETED'
  | 'AUTODRAFT_SETUP_COMPLETED'
  | 'AUTODRAFT_DRAFT_GENERATED'
  | 'AUTODRAFT_DRAFT_GENERATION_COMPLETE'
  | 'AUTODRAFT_DRAFT_VIEWED'
  | 'AUTODRAFT_DRAFT_ACCEPTED'
  | 'AUTODRAFT_DRAFT_EDITED'
  | 'APP_STUDIO_PUBLISHED'
  | 'APP_STUDIO_PUBLISH_FAILED'
  | 'APP_STUDIO_SHARED';
